import wsClient from "../../../lib/wsclient";
import { bindActionCreators } from "redux";
import store from "../store.js";
import General from "../helpers/General.js";
import { hashHistory } from "react-router";

import { setGlobalKey } from "../actions/General.js";

class BrowserNotifications {
    constructor() {
        if (typeof localStorage.notifications !== "undefined") {
            store.dispatch(
                setGlobalKey("notifications", localStorage.notifications)
            );
        }
    }

    new(data) {
        if (!("Notification" in window)) {
            return false;
        }

        if (store.getState().general.windowHasFocus !== false) {
            //return;
        }

        if (Notification.permission == "granted") {
            if (data.sound == true) {
                window.crall_audio.message_pling.play();
            }
            let notification = new Notification(data.title, {
                icon: "/icon/android-chrome-72x72.png",
                body: data.message
            });

            notification.onclick = function() {
                window.focus();
                if (data.link) {
                    hashHistory.push(data.link);
                }
                notification.close();
            };

            setTimeout(notification.close.bind(notification), 10000);
        }
    }

    askForNotifications() {
        if (!("Notification" in window)) {
            return false;
        }

        if (typeof localStorage.notifications !== "undefined") {
            return false;
        }

        if (store.getState().general.notifications !== null) {
            return false;
        }

        return true;
    }

    dontAskAgain() {
        localStorage.setItem("notifications", false);
        store.dispatch(setGlobalKey("notifications", false));
    }

    getPermission() {
        if (Notification.permission !== "denied") {
            Notification.requestPermission(function(permission) {
                if (permission === "granted") {
                    localStorage.setItem("notifications", true);
                    store.dispatch(setGlobalKey("notifications", true));
                }
            });
        } else {
            this.dontAskAgain();
        }
    }
}

export default new BrowserNotifications();




// WEBPACK FOOTER //
// ./components/BrowserNotification.js